import { Typography, Box } from '@mui/material';
import ftts from '../../Assets/AlertIcon/fttsblack.svg';
import otn from '../../Assets/AlertIcon/otnblack.svg';
import mpbn from '../../Assets/AlertIcon/MPBNNetwork.svg';
import ipran from '../../Assets/AlertIcon/IPRANNetwork.svg';
import { useAtomValue } from 'jotai';
import { backGroundColorMainScreen } from '../../common/atom/atoms';
import { useNavigate } from 'react-router-dom';
export const NetworkMonitoringSection = () => {
  const bg = useAtomValue(backGroundColorMainScreen);
  const navigate = useNavigate();
  const permissionsJSON = localStorage.getItem('permissions');
  let permissions = [];
  try {
    permissions = JSON.parse(permissionsJSON) || [];
  } catch (error) {
    console.error('Failed to parse permissions:', error);
  }
  const permissionNames = Array.isArray(permissions)
    ? permissions.map((permission) => permission.name)
    : [];

  const handleTabs = (tab) => {
    if (tab === 'FTTS') {
      sessionStorage.setItem('selectedTab', 'ftts');
      navigate('/fibers');
    }
    if (tab === 'MPBN') {
      sessionStorage.setItem('selectedTab', 'mpbn');
      navigate('/fibers');
    }
    if (tab === 'OTN') {
      sessionStorage.setItem('selectedTab', 'otn');
      navigate('/fibers');
    }
    if (tab === 'IPRAN') {
      sessionStorage.setItem('selectedTab', 'ipran');
      navigate('/fibers');
    }
  };

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          bottom: '230px',
          right: '30px',
          backgroundColor: 'black',
          color: '#192126',
          fontSize: '12px',
          fontFamily: 'Inter',
          fontWeight: 500,
          px: 2,
          py: 1,
          borderRadius: '16px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          animation: 'scaleFadeIn 1s ease-out forwards',
          opacity: 0,
          '&::after': {
            content: '""',
            position: 'absolute',
            top: '100%',
            left: '20px',
            width: 0,
            height: 0,
            borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent',
            borderTop: '8px solid white',
          },
        }}
      >
        Network Monitoring
      </Box>
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          right: 0,
          width: '230px',
          height: '220px',
          backgroundColor: 'black',
          borderTopLeftRadius: '80px',
          zIndex: 10,
          padding: '16px',
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '12px',
            marginLeft: '10%',
            marginTop: '10%',
            '@keyframes fadeUp': {
              '0%': { opacity: 0, transform: 'translateY(20px)' },
              '100%': { opacity: 1, transform: 'translateY(0)' },
            },
            '@keyframes dance': {
              '0%': { transform: 'rotate(0deg)' },
              '25%': { transform: 'rotate(3deg)' },
              '50%': { transform: 'rotate(-3deg)' },
              '75%': { transform: 'rotate(3deg)' },
              '100%': { transform: 'rotate(0deg)' },
            },
          }}
        >
          {[
            { img: ftts, label: 'FTTS' },
            { img: mpbn, label: 'MPBN' },
            { img: otn, label: 'OTN' },
            { img: ipran, label: 'IPRAN' },
          ]
            .filter((item) => permissionNames?.includes(item.label))
            .map((item, index) => (
              <Box
                key={item.label}
                onClick={() => handleTabs(item.label)}
                sx={{
                  width: '80px',
                  height: '80px',
                  // background: bg,
                  background: '#f8e8e9',
                  borderRadius: '16px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  animation: `fadeUp 0.5s ease ${index * 0.1}s both`,
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    animation: 'dance 0.6s ease-in-out',
                    boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
                  },
                }}
              >
                <img src={item.img} alt={item.label} style={{ width: '24px', height: '24px' }} />
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: '12px',
                    marginTop: '4px',
                  }}
                >
                  {item.label}
                </Typography>
              </Box>
            ))}
        </Box>
      </Box>
    </>
  );
};
